import { createFileRoute } from '@tanstack/react-router';
import { CampaignSentRouteView } from '@/pages/workspaces/automations/[campaignId]/sent/routing';

function CampaignSentIndexRoute() {
  const { campaignId } = Route.useParams();
  return <CampaignSentRouteView campaignId={campaignId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/sent/')({
  component: CampaignSentIndexRoute,
});
